<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title">ALTERAR PARCELAS</h3>
  </div>
  <div class="modal-body">
    <form [formGroup]="alterarValorForm" class="forms modal-alterar-valor">
      <div class="inputs">
        <h4 class="modal-alterar-valor-label" for="valorFinanciamento">Opções disponíveis</h4>
        <select formControlName="quantidadeParcelas"
          name="quantidadeParcelas"
          appShowErrorMessages
          requiredMessage="Selecione a quantidade de parcelas"
          class="form-control">
          <option *ngFor="let item of parcelasPersonalizada" value="{{ item }}">{{ item }}x</option>
        </select>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="marginT30 form-group tab-buttons">
        <a class="bt-back btn btn-border-orange pull-left" (click)="close()"> Fechar</a>
        <button type="button" class="bt-go btn btn-full-orange pull-right"
          (click)="onPersonalizarParcela()">
          Ok
        </button>
      </div>
    </div>
  </div>
</div>
